<template>
    <v-dialog :value="visible" persistent max-width="480px" @keydown.esc="$emit('close')">
        <v-card>
            <v-card-title class="text-subtitle-1">
                Alterar vencimento — cobrança {{ cobranca.external_id }}
            </v-card-title>

            <v-divider/>

            <v-card-text class="pt-4">
                <div class="text-caption grey--text mb-3">
                    {{ cobranca.empresa_fantasia }} · vencimento atual
                    {{ formatDate(cobranca.vencimento, 'DD/MM/YYYY') }}
                </div>

                <v-text-field
                    v-model="vencimento"
                    label="Novo vencimento"
                    type="date"
                    outlined
                    dense
                    hide-details
                />
            </v-card-text>

            <v-card-actions>
                <v-btn text small @click="$emit('close')">Cancelar</v-btn>
                <v-spacer/>
                <v-btn color="primary" small :loading="salvando" @click="confirmar">Confirmar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
/**
 * Alteração de vencimento a partir da tela de consulta.
 *
 * Difere do dialog de `views/financeiro`, que lê a empresa da rota (`/financeiro/:emp`): aqui cada
 * linha é de uma empresa diferente, então a empresa vem da própria cobrança. O identificador que a
 * API espera é o `charge_id` da EFI, que na tabela local é `external_id`.
 */
export default {
    name: 'AlterarVencimentoDialog',

    props: {
        visible: {
            type: Boolean,
            default: false,
        },

        cobranca: {
            type: Object,
            default: () => ({}),
        },
    },

    data: () => ({
        vencimento: '',
        salvando: false,
    }),

    watch: {
        visible(aberto) {
            if (aberto) {
                this.vencimento = this.moment().format('YYYY-MM-DD');
            }
        },
    },

    methods: {
        confirmar() {
            if (!this.vencimento) {
                this.notify('Informe o novo vencimento', 'warning');
                return;
            }

            this.salvando = true;

            this.$http.put(`cobrancas/${this.cobranca.external_id}/alterar-vencimento`, {
                empresa_id: this.cobranca.empresa_id,
                vencimento: this.vencimento,
            })
                .then(resp => {
                    if (resp.data && resp.data.type === 'warning') {
                        this.notify(resp.data.message || 'Não foi possível alterar', 'warning');
                        return;
                    }

                    this.notify('Vencimento alterado');
                    this.$emit('salvo');
                    this.$emit('close');
                })
                .catch(() => {
                    this.notify('Não foi possivel concluir a operação', 'warning');
                })
                .finally(() => (this.salvando = false));
        },
    },
};
</script>
